// SidebarPanel.jsx
import React from 'react';
import CoordinateInput from './maps/Map/CoordinateInput/CoordinateInput';
import Table from '../component/Data/Table/Table';
import Calender from '../component/Calender/Calender';
import { appText } from '../../src/texts'
const { mapText } = appText

const SidebarPanel = ({
    mapRef,
    selectedFeature,
    onStartDateSelect,
    onEndDateSelect,
    handleGetData,
    isLoading,
    selectedLocId,
    startDate,
    endDate,
    showDownloadButton,
    downloadCSV,
    onAddMarker
}) => {
    return (
        <div className=" w-full h-[100vh] bg-gray-100 p-4 flex flex-col gap-4 md:overflow-y-auto max-h-[calc(100vh-100px)]">
            <div className="container-marker space-y-4">
                <CoordinateInput onAddMarker={onAddMarker} mapRef={mapRef} />
                <Table selectedFeature={selectedFeature} />
                <Calender onStartDateSelect={onStartDateSelect} onEndDateSelect={onEndDateSelect} />
                <button
                    className={`w-full py-[8px] px-[10px] rounded-lg text-white ${selectedLocId && startDate && endDate
                        ? 'bg-[#02BFE7] hover:bg-[#056275]'
                        : 'bg-[#808080] cursor-not-allowed'
                        } `}
                    onClick={handleGetData}
                    disabled={!selectedLocId && startDate && endDate}
                >
                    {isLoading ? (
                        <p className="text-[12px]">در حال دریافت...</p>
                    ) : (
                        <p className="text-[12px]">{mapText.getDataText}</p>
                    )}
                </button>
                {showDownloadButton && (
                    <button
                        className={`w-full py-2 px-4 rounded-lg bg-green-600 text-white text-[14px] cursor-pointer`}
                        onClick={downloadCSV}
                    >
                        دانلود CSV
                    </button>
                )}
            </div>
        </div>
    );
};

export default SidebarPanel;
